// this is an autogenerated file from App/Account/Topbar/Inbox/Content/Content/Messages/Unread/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Topbar_Inbox_Content_Content_Messages_Unread{
  notifications_users(
    where: {
      status: { _eq: UNREAD }
      notification: { tags: { _contains: "inbox" } }
    }
    order_by: { notification: { created_at: desc } }
  ) {
    id
    status
    notification {
      id
      metadata(path: "$.payload")
      created_at
      resource_id
      resource_table
      resource_schema
    }
  }
}

`